import React, { FunctionComponent, useEffect, useState } from 'react';
import t from 'react-translate';
import moment from 'moment';
import { useAppDispatch } from 'redux/store';
import { isEmpty, reduce } from 'underscore';
import { LiveEventSession } from 'redux/schemas/models/live-event';
import { getRegisteredSessionDetails } from 'redux/actions/live-events';
import { BasicTableColumn, ColumnType, NvBasicTable } from 'shared/components/nv-basic-table';
import NvModal, { ModalType } from 'shared/components/nv-modal';
import LoadingWrapper, { LoaderType } from 'shared/components/loading-wrapper';

const NameRow = (props: { fullName: string, email: string }) => (
  <React.Fragment>
    <div className='text-regular'>{props.fullName}</div>
    <div className='text-regular'>{props.email}</div>
  </React.Fragment>
);
type RegisteredDetailsModalProps = {
  catalogId: string
  registeredSession: LiveEventSession
  show: boolean
  onClose: () => void
};

const RegisteredDetailsModal = ({
  catalogId,
  registeredSession,
  show,
  onClose,
}: RegisteredDetailsModalProps) => {
  const [registeredUsers, setRegisteredUsers] = useState({});

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (show && isEmpty(registeredUsers)) {
      dispatch(getRegisteredSessionDetails({
        catalogId,
        liveSessionId: registeredSession.id,
      }))
        .then(result => {
          const userData = reduce(
            result?.payload?.registeredUsers,
            (users, user) => {
              users[user.id] = user;
              return users;
            },
            {},
          );
          setRegisteredUsers(userData);
        });
    }
  }, [catalogId, dispatch, registeredSession.id, registeredUsers, show]);

  const cols: BasicTableColumn[] = [
    {
      key: 'fullName',
      name: '',
      className: 'column',
      sortable: false,
      gridWidth: '60%',
      type: ColumnType.STRING,
    },
    {
      key: 'email',
      name: '',
      className: 'column',
      sortable: false,
      gridWidth: '40%',
      type: ColumnType.STRING,
    },
  ];

  const body = () => (
    <div className='d-flex flex-column px-7 mt-4'>
      <div className='text-large-regular font-weight-bolder'>
        {registeredSession?.title}
      </div>
      <div className='text-date'>
        {moment(registeredSession?.startTime).format('LLL')}
      </div>
      <div className='text-regular font-weight-bolder'>
        {t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.COUNT(registeredSession?.totalRegisteredUsersCount)}
      </div>
      <LoadingWrapper
        loaderType={LoaderType.PLACEHOLDER}
        isLoaded={!isEmpty(registeredUsers)}
        className='w-100 mt-5'
      >
        <NvBasicTable<JSX.Element, { id: number, fullName: string, email: string }>
          columns={cols}
          tabledata={registeredUsers as any}
          rowComponent={NameRow as FunctionComponent}
          rowClass='p-3'
          showHeader={false}
          highlightClass=''
        />
      </LoadingWrapper>
    </div>
  );

  return (
    <NvModal
      show={show}
      type={ModalType.DYNAMIC}
      header={t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.TITLE()}
      body={body()}
      onClose={onClose}
    />
  );
};

export default RegisteredDetailsModal;
